import { __decorate, __metadata } from "tslib";
import { CacheActivePromise } from '@1inch-community/core/decorators';
import { ChainId, } from '@1inch-community/models';
import { startWith, switchMap } from 'rxjs';
import { BlockTimeCache, getWrapperNativeToken, isNativeToken } from '../../chain';
import { oneInchOracleAdapter } from './adapters/one-inch-oracle-adapter';
export class TokenRateProvider {
    constructor(onChainAdapters) {
        this.onChainAdapters = onChainAdapters;
        this.rateCache = new BlockTimeCache();
    }
    async init(context) {
        this.context = context;
        await Promise.all(this.onChainAdapters.map((adapter) => adapter.init(context)));
    }
    async getOnChainRate(chainId, sourceToken, destinationToken) {
        const rate = await this.getOnChainRawRate(chainId, sourceToken, destinationToken);
        if (rate.length === 0)
            return null;
        const getRateVale = (rate) => (rate.isReverted ? rate.revertedRate : rate.rate);
        let maxRate = rate[0];
        for (const item of rate) {
            if (getRateVale(item) > getRateVale(maxRate)) {
                maxRate = item;
            }
        }
        return maxRate;
    }
    listenOnChainRate(chainId, sourceToken, destinationToken) {
        if (!this.context) {
            throw new Error('TokenRateProvider not initialized');
        }
        return this.context.onChain.getBlockEmitter(chainId).pipe(startWith(null), switchMap(() => this.getOnChainRate(chainId, sourceToken, destinationToken)));
    }
    async getOnChainRawRate(chainId, sourceToken, destinationToken) {
        let _srcToken = sourceToken;
        let _dstToken = destinationToken;
        if (isNativeToken(sourceToken.address)) {
            const wToken = getWrapperNativeToken(chainId);
            if (!wToken)
                return [];
            _srcToken = wToken;
        }
        if (isNativeToken(destinationToken.address)) {
            const wToken = getWrapperNativeToken(chainId);
            if (!wToken)
                return [];
            _dstToken = wToken;
        }
        const id = [_srcToken.address, _dstToken.address].join(':');
        const cacheRateList = this.rateCache.get(chainId, id);
        if (cacheRateList !== null) {
            return cacheRateList;
        }
        const sources = this.onChainAdapters.filter((source) => source.isSupportedChain(chainId));
        const rateResultList = await Promise.all(sources.map((source) => source.getRate(chainId, _srcToken, _dstToken)));
        const cleanRateList = rateResultList.filter((rate) => rate !== null);
        this.rateCache.set(chainId, id, cleanRateList);
        return cleanRateList;
    }
}
__decorate([
    CacheActivePromise(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object, Object]),
    __metadata("design:returntype", Promise)
], TokenRateProvider.prototype, "getOnChainRate", null);
export function buildDefaultTokenRateProvider() {
    return new TokenRateProvider([oneInchOracleAdapter]);
}
//# sourceMappingURL=token-rate.provider.js.map